{
	"title": "Lijnen",
	"description": "Een lijn is een reeks pakken van dezelfde navulling: dezelfde pasvorm en hetzelfde doekje, een ander aantal per verpakking. De shop zet de pakken van een lijn naast elkaar, met wat je bespaart op het grote pak. Welk product in welke lijn zit, kies je in de productbewerker.",
	"list": "Lijnen",
	"empty": "Er zijn nog geen lijnen. Maak hieronder de eerste.",
	"column": {
		"name": "Lijn",
		"products": "Producten",
		"actions": "Acties"
	},
	"noProducts": "Nog geen producten",
	"productCount_one": "{{count}} product",
	"productCount_other": "{{count}} producten",
	"new": {
		"title": "Lijn toevoegen",
		"submit": "Toevoegen"
	},
	"edit": {
		"button": "Hernoemen: {{name}}",
		"title": "{{name}} hernoemen",
		"submit": "Opslaan",
		"cancel": "Annuleren"
	},
	"field": {
		"name": "Naam",
		"namePlaceholder": "Bijvoorbeeld Nimbus Magic Floorwipes XXL",
		"nameDescription": "De naam van de navulling, zonder het aantal per verpakking."
	},
	"delete": {
		"button": "Verwijderen: {{name}}",
		"title": "{{name}} verwijderen?",
		"description": "De lijn verdwijnt. Dit kun je niet ongedaan maken.",
		"confirm": "Verwijderen",
		"notEmpty": "Verwijderen kan pas als er geen producten meer in zitten. Haal ze eruit in de productbewerker."
	},
	"error": {
		"nameTaken": "Er is al een lijn met deze naam.",
		"notFound": "Deze lijn bestaat niet meer. Laad de pagina opnieuw.",
		"notEmpty": "Er zitten intussen producten in deze lijn. Haal ze eerst uit de lijn in de productbewerker."
	},
	"help": {
		"lines": {
			"title": "Lijnen",
			"area": "Producten › Lijnen",
			"short": "Een lijn is dezelfde navulling in pakken van een ander aantal, zoals Floorwipes XXL 20, 60 en 100. Elk pak is een eigen product. De shop zet de pakken naast elkaar, met wat je bespaart.",
			"warning": "Een product zit in hooguit één lijn; wissers, startpakketten en sets zitten in geen. Een lijn met producten kan niet weg: haal de producten er eerst uit in de productbewerker, onder Indeling.",
			"terms": ["product:pack", "product:pricePerPiece", "productLine:add"],
			"goTo": {
				"to": "/product/line",
				"label": "Naar Lijnen"
			}
		},
		"add": {
			"title": "Lijn toevoegen",
			"area": "Producten › Lijnen",
			"short": "Geef de lijn de naam van de navulling, zonder het aantal: Floorwipes XXL. Daarna kies je per pak de lijn in de productbewerker, onder Indeling. Een product zit in hooguit één lijn.",
			"terms": ["product:catalog"]
		}
	}
}
